import { buildCsrfToken, decrypt, encryptedParamsDynamic, testData, testNumber, url, restoreCryptoKey, cryptoKey } from "../decrypt";
import logger from "utils/logger";
const controller = new AbortController();
const signal = controller.signal;

async function getKyc(payload_from_url) {
    try {
        let payload = { customerId: payload_from_url };
        let encryptedParamsFromUrlPayload = encryptedParamsDynamic(payload);
        let csrfTokenFromUrlPayload = buildCsrfToken(encryptedParamsFromUrlPayload);

        const fetchDataPromise = fetch(`${url}/${testData[testNumber].api}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                csrfToken: csrfTokenFromUrlPayload,
                rid: 1,
            },
            // body: JSON.stringify({ params: encryptedParams }), // static encryption
            body: JSON.stringify({
                params: encryptedParamsFromUrlPayload,
            }), // dynamic encryption
            // controller
            signal,
        });

        const timeoutId = setTimeout(() => {
            controller.abort();
        }, 20000);

        const fetchData = await fetchDataPromise;

        let response = null;
        if (fetchData.ok) {
            clearTimeout(timeoutId);
            response = await fetchData.json();
        } else {
            response = [{ status: "FAILED" }];
        }
        return response;
    } catch (error) {
        if (error.name === "AbortError") {
            console.log("aborted", error.name);
            return [{ status: "TIMEOUT REACHED" }];
        } else {
            console.log("error", error);
        }
    }
}

async function decryptKyc(payload_from_url) {
    if (cryptoKey === "") {
        await restoreCryptoKey();
        logger.log("kyc-get service", "key restored", null);
    }
    const toDecrypt = await getKyc(payload_from_url);
    let response = null;
    if (toDecrypt["status"] === "SUCCESS") {
        const successresponse = [{ status: toDecrypt["status"] }, JSON.parse(decrypt(toDecrypt["response"]))];
        // response = JSON.parse(decrypt(toDecrypt["response"]));
        response = successresponse;
    } else {
        response = toDecrypt;
    }
    return response;
}

export { decryptKyc };
